export default function ImageUploader () {
    return null
}